(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snf-garment-minimum-preview"]) return;
  try {
    
  (() => {
    if (document.documentElement.classList.contains('snf-wholesale-active')) return;
    const dataRoot = document.querySelector('[data-snf-garment-minimum]');
    if (!dataRoot || window.SNFGarmentMinimumPreview) return;

    const api = {
      state: { items: [], groups: [], incomplete: [], unconfigured: [] }
    };
    window.SNFGarmentMinimumPreview = api;

    if (dataRoot.dataset.currentProductGarment === 'true') {
      document.documentElement.classList.add('snf-garment-product');
    }

    const checkoutSelector =
      '[name="checkout"], a[href^="/checkout"], button[data-checkout]';
    const mountAnchors = [
      '#CartDrawer .cart__ctas',
      '#main-cart-footer .cart__ctas',
      '.cart__footer .cart__ctas',
      'form[action*="/cart"] [name="checkout"]'
    ];
    const desktopCartQuery = window.matchMedia('(min-width: 990px)');
    let refreshTimer;
    let mountTimer;
    let alertTimer;
    let internalMutation = false;

    function parseSnapshot(container) {
      const node = container?.querySelector('[data-snf-garment-snapshot]');
      if (!node) return { items: [] };
      try {
        return JSON.parse(node.textContent);
      } catch (_error) {
        return { items: [] };
      }
    }

    function buildState(snapshot) {
      const groups = new Map();
      const unconfigured = [];

      for (const item of snapshot.items ?? []) {
        if (!item.isGarment) continue;
        if (!item.groupKey || !item.groupLabel || !item.collectionHandle) {
          unconfigured.push(item.title || 'Garment');
          continue;
        }

        const current = groups.get(item.groupKey) ?? {
          key: item.groupKey,
          label: item.groupLabel,
          minimum: 4,
          collectionHandle: item.collectionHandle,
          quantity: 0,
          lineKeys: []
        };
        current.quantity += Math.max(0, Number(item.quantity) || 0);
        current.lineKeys.push(item.key);
        groups.set(item.groupKey, current);
      }

      const groupList = [...groups.values()];
      return {
        items: snapshot.items ?? [],
        groups: groupList,
        incomplete: groupList.filter(
          (group) => group.quantity > 0 && group.quantity < group.minimum
        ),
        unconfigured
      };
    }

    function createElement(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    }

    function ensureCartUpdateButton() {
      const cartItems = document.querySelector('#main-cart-items');
      const cartRoot =
        cartItems?.closest('cart-items') ??
        cartItems?.closest('.page-width');
      const titleWrapper = cartRoot?.querySelector(
        '.title-wrapper-with-link'
      );
      if (!titleWrapper) return;

      const existingActions = titleWrapper.querySelector(
        ':scope > .snf-cart-header-actions'
      );
      if (existingActions) return;

      const continueLink = [...titleWrapper.querySelectorAll('a')].find(
        (link) =>
          link.textContent.trim().toLowerCase() === 'continue shopping'
      );
      const cartForm =
        cartItems?.closest('form[action*="/cart"]') ??
        cartRoot.querySelector('form[action*="/cart"]') ??
        document.querySelector('form[action*="/cart"]');
      if (!continueLink || !cartForm) return;

      if (!cartForm.id) cartForm.id = 'SNFCartUpdateForm';

      const actions = createElement('div', 'snf-cart-header-actions');
      const updateButton = createElement(
        'button',
        'snf-cart-update',
        'Update cart'
      );
      updateButton.dataset.snfCartUpdate = '';
      updateButton.type = 'submit';
      updateButton.name = 'update';
      updateButton.value = 'Update cart';
      updateButton.setAttribute('form', cartForm.id);

      titleWrapper.insertBefore(actions, continueLink);
      actions.append(updateButton, continueLink);
    }

    function markGarmentPriceRows(state) {
      const cartItems = document.querySelector('#main-cart-items');
      if (!cartItems) return;

      for (const row of cartItems.querySelectorAll(
        '.cart-item.snf-garment-line'
      )) {
        row.classList.remove('snf-garment-line');
      }

      for (const [index, item] of (state.items ?? []).entries()) {
        if (!item.isGarment) continue;
        const row = document.getElementById(`CartItem-${index + 1}`);
        row?.classList.add('snf-garment-line');
      }
    }

    function createMount(anchor) {
      const existing = anchor.parentElement?.querySelector(
        ':scope > [data-snf-minimum-mount]'
      );
      if (existing) return existing;

      const mount = createElement('div', 'snf-minimum-mount');
      mount.dataset.snfMinimumMount = '';
      mount.setAttribute('aria-live', 'polite');
      anchor.parentElement?.insertBefore(mount, anchor);
      return mount;
    }

    function createCartPageMount() {
      const cartItems = document.querySelector('#main-cart-items');
      if (!cartItems) return null;

      const cartRoot =
        cartItems.closest('cart-items') ??
        cartItems.closest('.page-width');
      if (!cartRoot) return null;

      const existing = cartRoot.querySelector(
        ':scope > [data-snf-minimum-mount]'
      );
      if (existing) return existing;

      const mount = createElement(
        'aside',
        'snf-minimum-mount snf-minimum-mount--cart-page'
      );
      mount.dataset.snfMinimumMount = '';
      mount.setAttribute('aria-label', 'Garment order requirements');
      mount.setAttribute('aria-live', 'polite');
      cartRoot.classList.add('snf-minimum-cart-grid');
      cartRoot.prepend(mount);
      return mount;
    }

    function findMounts() {
      if (desktopCartQuery.matches) {
        const cartPageMount = createCartPageMount();
        if (cartPageMount) return [cartPageMount];
      }

      const mounts = [];
      for (const selector of mountAnchors) {
        const anchor = document.querySelector(selector);
        if (!anchor) continue;
        const normalizedAnchor = anchor.matches(checkoutSelector)
          ? anchor.parentElement
          : anchor;
        if (!normalizedAnchor?.parentElement) continue;
        const mount = createMount(normalizedAnchor);
        if (!mounts.includes(mount)) mounts.push(mount);
      }
      return mounts;
    }

    function renderMount(mount) {
      internalMutation = true;
      mount.replaceChildren();
      if (!api.state.groups.length && !api.state.unconfigured.length) {
        if (mount.classList.contains('snf-minimum-mount--cart-page')) {
          mount.parentElement?.classList.remove('snf-minimum-cart-grid');
        }
        mount.remove();
        window.setTimeout(() => {
          internalMutation = false;
        }, 0);
        return;
      }

      const panel = createElement('div', 'snf-minimum-panel');
      const hasIssue =
        api.state.incomplete.length > 0 || api.state.unconfigured.length > 0;
      panel.append(
        createElement(
          'p',
          'snf-minimum-heading',
          hasIssue ? 'Garment minimums' : 'Garment minimums met ✓'
        )
      );

      const list = createElement('ul', 'snf-minimum-list');
      for (const group of api.state.groups) {
        const complete = group.quantity >= group.minimum;
        const row = createElement(
          'li',
          `snf-minimum-row${complete ? ' snf-minimum-row--complete' : ''}`
        );
        row.append(createElement('span', 'snf-minimum-label', group.label));
        row.append(
          createElement(
            'span',
            'snf-minimum-count',
            `${group.quantity} of ${group.minimum}`
          )
        );
        const missing = group.minimum - group.quantity;
        row.append(
          createElement(
            'span',
            'snf-minimum-status',
            complete
              ? 'Minimum met ✓'
              : `Add ${missing} more ${missing === 1 ? 'item' : 'items'}`
          )
        );

        if (!complete) {
          const actions = createElement('span', 'snf-minimum-actions');
          const addLink = createElement(
            'a',
            'snf-minimum-link',
            `Add more ${group.label}`
          );
          addLink.href = `/collections/${encodeURIComponent(
            group.collectionHandle
          )}`;
          actions.append(addLink);

          const removeButton = createElement(
            'button',
            'snf-minimum-remove',
            'Remove this category'
          );
          removeButton.type = 'button';
          removeButton.addEventListener('click', (event) =>
            removeGroup(group, event.currentTarget)
          );
          actions.append(removeButton);
          row.append(actions);
        }
        list.append(row);
      }
      panel.append(list);

      if (api.state.unconfigured.length) {
        panel.append(
          createElement(
            'p',
            'snf-minimum-notice',
            'One garment needs a category before checkout. Please contact us and we’ll help right away.'
          )
        );
      }

      const isMiniCart = Boolean(
        mount.closest(
          'cart-notification, #cart-notification, #CartDrawer, cart-drawer'
        )
      );

      const orderNotice = createElement(
        'div',
        'snf-minimum-order-notice'
      );

      if (!isMiniCart) {
        const attentionContent = createElement(
          'div',
          'snf-minimum-attention-content'
        );
        const noticeHeading = createElement(
          'p',
          'snf-minimum-order-notice__heading',
          'Notice — Please Read'
        );
        const attentionArrow = createElement(
          'span',
          'snf-minimum-attention-arrow',
          '←'
        );
        attentionArrow.setAttribute('aria-hidden', 'true');
        noticeHeading.append(attentionArrow);
        attentionContent.append(noticeHeading);

        const checkoutNotice = createElement('p');
        checkoutNotice.append(
          createElement(
            'strong',
            '',
            'Checkout will show a $0 value.'
          ),
          document.createTextNode(
            ' We validate stock and then issue your invoice.'
          )
        );
        attentionContent.append(checkoutNotice);
        orderNotice.append(attentionContent);
      }

      const shippingNotice = createElement('p');
      shippingNotice.append(
        createElement(
          'strong',
          '',
          '🚚 Free shipping on garment orders over $300.'
        )
      );
      orderNotice.append(shippingNotice);
      panel.append(orderNotice);

      mount.append(panel);
      window.setTimeout(() => {
        internalMutation = false;
      }, 0);
    }

    function render(state) {
      api.state = state;
      document.documentElement.classList.toggle(
        'snf-garment-cart',
        state.groups.length > 0 || state.unconfigured.length > 0
      );
      document.documentElement.classList.toggle(
        'snf-minimum-incomplete',
        state.incomplete.length > 0 || state.unconfigured.length > 0
      );
      markGarmentPriceRows(state);
      ensureCartUpdateButton();
      for (const mount of findMounts()) renderMount(mount);
    }

    async function removeGroup(group, button) {
      button.disabled = true;
      const updates = Object.fromEntries(
        group.lineKeys.map((lineKey) => [lineKey, 0])
      );
      try {
        const response = await fetch(window.routes?.cart_update_url ?? '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (_error) {
        button.disabled = false;
      }
    }

    async function refresh() {
      try {
        const cartUrl = window.routes?.cart_url ?? '/cart';
        const response = await fetch(
          `${cartUrl}?snf_minimum_snapshot=${Date.now()}`,
          {
            credentials: 'same-origin',
            headers: { Accept: 'text/html' },
            cache: 'no-store'
          }
        );
        const html = await response.text();
        const documentCopy = new DOMParser().parseFromString(html, 'text/html');
        const freshRoot = documentCopy.querySelector(
          '[data-snf-garment-minimum]'
        );
        render(buildState(parseSnapshot(freshRoot)));
      } catch (_error) {
        render(buildState(parseSnapshot(dataRoot)));
      }
    }

    function scheduleRefresh(delay = 700) {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, delay);
    }

    function focusMinimumMessage() {
      for (const mount of findMounts()) {
        if (mount.offsetParent === null) continue;
        if (!mount.querySelector('.snf-minimum-panel')) renderMount(mount);
        mount.tabIndex = -1;
        mount.focus();
        mount.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }

    function showMinimumAlert() {
      window.clearTimeout(alertTimer);
      for (const mount of findMounts()) {
        if (mount.offsetParent === null) continue;
        if (!mount.querySelector('.snf-minimum-panel')) renderMount(mount);
        const panel = mount.querySelector('.snf-minimum-panel');
        if (!panel) continue;
        panel.classList.remove('snf-minimum-panel--checkout-alert');
        void panel.offsetWidth;
        panel.classList.add('snf-minimum-panel--checkout-alert');
      }

      alertTimer = window.setTimeout(() => {
        for (const panel of document.querySelectorAll(
          '.snf-minimum-panel--checkout-alert'
        )) {
          panel.classList.remove('snf-minimum-panel--checkout-alert');
        }
      }, 4000);
    }

    function ensureMinimumDialog() {
      const existing = document.querySelector(
        '[data-snf-minimum-dialog]'
      );
      if (existing instanceof HTMLDialogElement) return existing;

      const dialog = createElement('dialog', 'snf-minimum-dialog');
      dialog.dataset.snfMinimumDialog = '';
      dialog.setAttribute(
        'aria-labelledby',
        'SNFGarmentMinimumDialogHeading'
      );

      const content = createElement(
        'div',
        'snf-minimum-dialog__content'
      );
      const heading = createElement(
        'h2',
        'snf-minimum-dialog__heading',
        'Garment minimums required'
      );
      heading.id = 'SNFGarmentMinimumDialogHeading';
      content.append(
        heading,
        createElement(
          'p',
          'snf-minimum-dialog__message',
          'Please make sure you have met all required garment minimums before checking out.'
        )
      );

      const list = createElement('ul', 'snf-minimum-dialog__list');
      list.dataset.snfMinimumDialogList = '';
      content.append(list);

      const returnButton = createElement(
        'button',
        'snf-minimum-dialog__button',
        'Return to cart'
      );
      returnButton.type = 'button';
      returnButton.addEventListener('click', () => dialog.close());
      content.append(returnButton);
      dialog.append(content);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () =>
        window.setTimeout(focusMinimumMessage, 0)
      );
      document.body.append(dialog);
      return dialog;
    }

    function showMinimumDialog() {
      const dialog = ensureMinimumDialog();
      const list = dialog.querySelector(
        '[data-snf-minimum-dialog-list]'
      );
      if (!list) return;

      list.replaceChildren();
      for (const group of api.state.incomplete) {
        const missing = Math.max(0, group.minimum - group.quantity);
        list.append(
          createElement(
            'li',
            '',
            `${group.label}: add ${missing} more ${
              missing === 1 ? 'item' : 'items'
            }.`
          )
        );
      }

      if (api.state.unconfigured.length) {
        list.append(
          createElement(
            'li',
            '',
            'One garment still needs a category before checkout.'
          )
        );
      }

      if (!dialog.open) dialog.showModal();
    }

    function handleBlockedCheckout() {
      showMinimumAlert();
      showMinimumDialog();
    }

    function checkoutIsBlocked() {
      return (
        api.state.incomplete.length > 0 || api.state.unconfigured.length > 0
      );
    }

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const checkout = target.closest(checkoutSelector);
        if (checkout && checkoutIsBlocked()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleBlockedCheckout();
          return;
        }

        if (
          target.closest(
            '[href*="/cart"], [data-cart-add], [data-cart-remove], cart-remove-button'
          )
        ) {
          scheduleRefresh();
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        const submitter = event.submitter;
        if (
          form instanceof HTMLFormElement &&
          submitter instanceof Element &&
          submitter.matches(checkoutSelector) &&
          checkoutIsBlocked()
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleBlockedCheckout();
          return;
        }
        if (form instanceof HTMLFormElement && form.action.includes('/cart/add')) {
          scheduleRefresh(900);
        }
      },
      true
    );

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (
        target instanceof Element &&
        target.matches('input[name="updates[]"], [data-cart-quantity]')
      ) {
        scheduleRefresh();
      }
    });

    for (const eventName of [
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'theme:cart:change'
    ]) {
      document.addEventListener(eventName, () => scheduleRefresh(150));
    }

    if (
      typeof window.subscribe === 'function' &&
      window.PUB_SUB_EVENTS?.cartUpdate
    ) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () =>
        scheduleRefresh(150)
      );
    }

    desktopCartQuery.addEventListener('change', () => {
      internalMutation = true;
      for (const mount of document.querySelectorAll(
        '[data-snf-minimum-mount]'
      )) {
        mount.remove();
      }
      for (const cartRoot of document.querySelectorAll(
        '.snf-minimum-cart-grid'
      )) {
        cartRoot.classList.remove('snf-minimum-cart-grid');
      }
      window.setTimeout(() => {
        internalMutation = false;
        render(api.state);
      }, 0);
    });

    const observer = new MutationObserver((records) => {
      if (internalMutation || !records.length) return;

      window.clearTimeout(mountTimer);
      mountTimer = window.setTimeout(() => {
        markGarmentPriceRows(api.state);
        ensureCartUpdateButton();
        for (const mount of findMounts()) {
          if (!mount.querySelector('.snf-minimum-panel')) renderMount(mount);
        }
      }, 80);
    });

    api.state = buildState(parseSnapshot(dataRoot));
    observer.observe(document.body, { childList: true, subtree: true });
    render(api.state);
    scheduleRefresh(100);
  })();

  } catch(e) { console.error(e); }
})();
})();
